import { LogLevelPolicy } from "./LogLevelPolicy";

export class LogLevelPolicyFactory {
  private readonly policy = new LogLevelPolicy();

  create(): LogLevelPolicy {
    return this.policy;
  }
}

export const logLevelPolicyFactory = new LogLevelPolicyFactory();
